import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams,useNavigate  } from "react-router-dom";

const ComparisionSupplierWithItemViewsingle = () => {
  useAuthRedirect();
   const navigate = useNavigate();
const {item} = useParams();
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    fetchData();
  }, [branch, item]);

  const fetchData = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/comparisionItem?item=${item}&branch=${branch}`)

      console.log("API Response:", response.data.comparisionItem);
      setData(response.data.comparisionItem);
      setFilteredData(response.data.comparisionItem); 
    } catch (error) {
      console.error("Error fetching comparisionItem:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Corrected Search Function
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
      setFilteredData(data); 
      return;
    }

    const filtered = data.filter((item) =>
      (item.itemmaster_name?.toLowerCase().includes(term) ||
       item.supplierWIdetail_itemcode?.toLowerCase().includes(term))
    );

    setFilteredData(filtered);
  };

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">

           <section>
            <div className="back-div">
              <h2 className="add-txt">Supplier with Item</h2>
              <p className="back-button" onClick={() => navigate(-1)} style={{cursor: 'pointer'}}><i className="fa-solid fa-backward"></i>Back</p>
              </div>
          <Time />
        </section>


        

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Indent No or Department Name"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>Uom</th>
                <th>Price</th>
                <th>Tax%</th>
                <th>P&F%</th>
                <th>Disc%</th>
                <th>Net Amount</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => {
                    const tax = item.supplierWIdetail_price * (item.SupplierWIDetail_CSTtax / 100);
                    const pf = item.supplierWIdetail_price * (item.supplierWIdetail_PfPercentage / 100);
                    const disc = item.supplierWIdetail_price * (item.supplierWIdetail_discountPercentage / 100);
                    const total = item.supplierWIdetail_price + tax + pf - disc;

                    return(
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.supplierWIdetail_itemcode}</td>
                    <td>{item.itemmaster_name}</td>
                    <td>{item.itemMaster_purchaseUom}</td>
                    <td>{item.supplierWIdetail_price.toFixed(2)}</td>
                    <td>{item.SupplierWIDetail_CSTtax}</td>
                    <td>{item.supplierWIdetail_PfPercentage}</td>
                    <td>{item.supplierWIdetail_discountPercentage}</td>
                    <td>{total.toFixed(2)}</td> 
                  </tr>
                    );
})
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComparisionSupplierWithItemViewsingle;
